import ReactConfetti from 'react-confetti'
import { useWindowSize } from 'react-use'
import { useThemeContext } from '../../Brand/ThemeProvider/ThemeProvider'
import { selectDesignSystemColors } from '../../hooks/useDesignSystem'
import { unbrandedColorPallette } from '../../DesignSystem/DesignSystem'
import type { SyntheticEvent } from 'react'
import { useState } from 'react'
import type { IRect } from 'react-confetti/src/Rect'

export function useConfettiState() {
  const [coords, setCoords] = useState({ x: 0, y: 0, w: 0, h: 0 })
  return {
    coords,
    takeCoordsFrom: ({ currentTarget }: SyntheticEvent) => {
      const { x, y, width, height } = currentTarget.getBoundingClientRect()
      setCoords({
        x,
        y,
        w: width,
        h: height,
      })
    },
  }
}

export function Confetti({ coords }: { coords: IRect }) {
  const { width, height } = useWindowSize()
  const { brandAlias } = useThemeContext()
  const { colors } = selectDesignSystemColors(
    brandAlias,
    ...unbrandedColorPallette,
  )

  return (
    <ReactConfetti
      width={width}
      height={height}
      confettiSource={coords}
      colors={colors}
      recycle={false}
      tweenDuration={3000}
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 10000,
      }}
    />
  )
}
